import { isEntriesTransaction, resolveTransactionTypeLabel } from "../../constants/transactionTypes"
import { summariesData } from "../../data/summariesData"
import type { ShiftInput, ShiftOutput } from "../../types/IShift"
import { moneyToEntries } from "../entriesToMoney"
import { formatAmount } from "../formattingFunctions/formatAmount"
import { formatDateAndTime } from "../formattingFunctions/formatDateAndTime"
import { formatName } from "../formattingFunctions/formatName"
import { formatPlayerNumber } from "../formattingFunctions/formatPlayerNumber"

export function flattenDrawer(input: ShiftInput): ShiftOutput {
  const transactions = input.transactions.map((transaction) => {
    const { formattedDate, formattedTime } = formatDateAndTime(transaction.timestamp)
    const name = formatName(
      transaction.firstName,
      transaction.lastName,
      transaction.userName,
      transaction.playerNumber
    )
    const playerNumber = formatPlayerNumber(transaction.userName, transaction.playerNumber)
    const transactionValue = isEntriesTransaction(transaction.transactionType)
      ? moneyToEntries(transaction.transactionValue).toLocaleString()
      : formatAmount(transaction.transactionValue)
    const transactionType = resolveTransactionTypeLabel(transaction.transactionType)

    return {
      ...transaction,
      name,
      playerNumber,
      date: formattedDate,
      time: formattedTime,
      transactionValue: transactionValue,
      transactionType: transactionType,
    }
  })

  const summaries = summariesData(input)

  const output: ShiftOutput = {
    shiftPOCO: input.shiftPOCO,
    total: input.total,
    transactions: transactions,
    summaries: summaries,
  }

  return output
}
